var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "width": "800",
      "persistent": ""
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-eye")]), _vm._v(" Visualizar Termo ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.content.nome,
      "label": "Nome do Termo*",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.content && _vm.content.tipo && _vm.content.tipo.descricao,
      "label": "Tipo de Termo*",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm._f("date")(_vm.content.dataInicio),
      "label": "Data Início*",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm._f("date")(_vm.content.dataFim),
      "label": "Data Fim*",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "mr-4"
  }, [_vm._v("Ações*:")]), _vm.content && _vm.content.acao ? _c('v-radio-group', {
    attrs: {
      "disabled": true,
      "row": ""
    },
    model: {
      value: _vm.content.acao.id,
      callback: function ($$v) {
        _vm.$set(_vm.content.acao, "id", $$v);
      },
      expression: "content.acao.id"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row"
  }, _vm._l(_vm.itemsRadioButtomAcoes, function (n) {
    return _c('v-radio', {
      key: n.id,
      staticClass: "mr-4",
      attrs: {
        "value": n.id,
        "label": n.descricao
      }
    });
  }), 1)]) : _vm._e()], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-editor-html', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.content.conteudo,
      callback: function ($$v) {
        _vm.$set(_vm.content, "conteudo", $$v);
      },
      expression: "content.conteudo"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "btn-group text-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  }, [_vm._v(" Fechar ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }